import { render, staticRenderFns } from "./JoinPrivacy.vue?vue&type=template&id=391535e5&scoped=true"
import script from "./JoinPrivacy.vue?vue&type=script&lang=js"
export * from "./JoinPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391535e5",
  null
  
)

export default component.exports